export const autocomplete = (theme) => ({
    /* Styles applied to the root element. */
    root: {},
    filled: {
        borderBottom: `2px solid ${theme.customPalette.secondaryYellowYButtons}`,
    },
    underline: {
        "&&&:before": {
            borderBottom: "none",
        },
        "&&:after": {
            borderBottom: "none",
        },
    },
    icon: {
        width: 24,
        height: 24,
    },
    input: {
        width: "100%",
    },
    subscriptionSelect: {
        height: "100%",
        "& input": {
            width: "100% !important",
        },
        "& .MuiFilledInput-root": {
            height: "100%",
            paddingRight: "40px !important",
        },
        "& .MuiAutocomplete-tag": {
            order: 1,
        },
        "& .MuiAutocomplete-endAdornment": {
            top: 12,
        },

        // "& .MuiAutocomplete-endAdornment": {
        //     position: "absolute",
        //     top: 0,
        //     display: "flex",
        //     flexDirection: "column-reverse",
        //     height: "100%",
        //     justifyContent: "space-around",
        // },
    },
});
